var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.loadingState === "loaded"
        ? [
            _c("QueryForm"),
            _vm._v(" "),
            _vm.resultsVisible
              ? _c("QuerySummary", {
                  staticClass: "cf-panel cf-panel-lg",
                  attrs: { id: "summary" },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.resultsVisible
              ? _c(
                  "Debug",
                  {
                    staticStyle: { margin: "0 -15px", "margin-bottom": "40px" },
                  },
                  [
                    _c("div", [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("searchPage.fullQuery")) + ": "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "pre",
                        [
                          _vm._l(_vm.debugQuery, function (v, k) {
                            return [
                              v != null && v !== ""
                                ? [
                                    _vm._v(_vm._s(k) + ": " + _vm._s(v)),
                                    _c("br"),
                                  ]
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("Results", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.resultsVisible,
                  expression: "resultsVisible",
                },
              ],
              attrs: { id: "results" },
            }),
            _vm._v(" "),
            _vm.pageGuideEnabled ? _c("PageGuide") : _vm._e(),
          ]
        : _c(
            "div",
            [
              _c("h2", [
                _vm.loadingState !== "loading"
                  ? _c("span", { staticClass: "fa fa-danger fa-4x" })
                  : _vm._e(),
                _vm._v("\n\t\t\t" + _vm._s(_vm.loadingMessage) + "\n\t\t"),
              ]),
              _vm._v(" "),
              _vm.loadingState === "loading"
                ? _c("Spinner", { attrs: { center: "" } })
                : _vm.loadingState === "requiresLogin"
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-primary",
                      attrs: { type: "button" },
                    },
                    [_vm._v("login (todo)")]
                  )
                : _vm._e(),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }